// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['it_IT']  = {
  "name": "it_IT",
  "day": {
    "abbrev": [
      "dom",
      "lun",
      "mar",
      "mer",
      "gio",
      "ven",
      "sab"
    ],
    "full": [
      "domenica",
      "lunedì",
      "martedì",
      "mercoledì",
      "giovedì",
      "venerdì",
      "sabato"
    ]
  },
  "month": {
    "abbrev": [
      "gen",
      "feb",
      "mar",
      "apr",
      "mag",
      "giu",
      "lug",
      "ago",
      "set",
      "ott",
      "nov",
      "dic"
    ],
    "full": [
      "gennaio",
      "febbraio",
      "marzo",
      "aprile",
      "maggio",
      "giugno",
      "luglio",
      "agosto",
      "settembre",
      "ottobre",
      "novembre",
      "dicembre"
    ]
  },
  "meridiem": [
    "",
    ""
  ],
  "date": "%d/%m/%Y",
  "time24": "%T",
  "dateTime": "%a %d %b %Y %T %Z",
  "time12": "",
  "full": "%a %e %b %Y, %H.%M.%S, %Z"
}

